import useStore from 'stores/utils/hooks/useStore'
import { trackVoucherActivation } from '../helpers/trackVoucherActivation'

interface UseVoucherActivationReturn {
  isVoucherActivated: boolean
  activateVoucher: (campaignId: string) => void
}

const useVoucherActivation = (): UseVoucherActivationReturn => {
  const {
    traversalSession,
    traversal: { data }
  } = useStore()

  const activateVoucher = (campaignId: string) => {
    if (traversalSession.isVoucherActivated) return

    traversalSession.setIsVoucherActivated(true)
    trackVoucherActivation(data, campaignId)
  }

  return {
    isVoucherActivated: traversalSession.isVoucherActivated,
    activateVoucher
  }
}

export default useVoucherActivation
